import { MasterDialog } from "#common/Dialog/Dialog"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import { useApiSend } from "#hooks/useApiSend"
import AddBoxIcon from "@mui/icons-material/AddBox"
import { Button, Skeleton, Typography } from "@mui/material"
import { Fragment, useCallback, useEffect, useMemo, useState } from "react"
import { JobProfileTableStyle } from "./job-profile-table/JobProfileTableStyle"

export default function JobProfileItem({
	profileId,
	apiGet,
	apiDelete,
	messageDelete,
	AddForm,
	excluded,
	autoFetch = true,
	tableItems = [],
	name = "",
	noEdit = false,
}) {
	const [reload, setReload] = useState(false)
	const [open, setOpen] = useState(false)
	const [datum, setDatum] = useState({})
	const refresh = useCallback(() => setReload(!reload), [reload, setReload])
	const params = useMemo(() => ({ profileId }), [profileId])
	const options = useMemo(
		() => ({ autoFetch, params, reload }),
		[autoFetch, params, reload]
	)
	const { data, error, loading } = useApi(apiGet, options)
	useEffect(() => {}, [apiGet, name, reload])

	const itemsExcluded = useMemo(() => {
		if (!excluded) return []

		const datos = data?.data || []
		return datos.map((item) => {
			return item[excluded]
		})
	}, [data?.data, excluded])

	if (loading) return <Skeleton variant="rectangular" height={200} />
	if (error) return <ErrorResponse api={error} />

	return (
		<Fragment>
			<JobProfileTableStyle
				{...{
					items: tableItems,
					data: data?.data || [],
					actions: noEdit ? null : (
						<AddDatum
							{...{ profileId, refresh, name, AddForm, excluded: itemsExcluded }}
						/>
					),
				}}
				onDelete={(datum) => {
					setDatum(datum)
					setOpen(true)
				}}
				noEdit={noEdit}
			/>
			<DeleteDialog
				open={open}
				setOpen={setOpen}
				refresh={refresh}
				datum={datum}
				apiDelete={apiDelete}
				messageDelete={messageDelete}
				name={name}
			/>
		</Fragment>
	)
}
const AddDatum = ({ profileId, refresh, name, AddForm, excluded }) => {
	const [open, setOpen] = useState(false)
	return (
		<Fragment>
			<Button onClick={() => setOpen(true)} startIcon={<AddBoxIcon />}>
				Agregar {name}
			</Button>
			<AddForm {...{ open, setOpen, profileId, refresh, excluded }} />
		</Fragment>
	)
}

const DeleteDialog = ({
	open,
	setOpen,
	datum,
	refresh,
	apiDelete,
	messageDelete,
	name,
}) => {
	const [disabled, setDisabled] = useState(false)
	const success = () => {
		setOpen(false)
		refresh()
	}
	const end = () => {
		setOpen(false)
		setDisabled(false)
	}
	const { fetch } = useApiSend(apiDelete, { success, end })

	const buttons = useMemo(
		() => [
			{
				label: "Cancelar",
				onClick: () => {
					setOpen(false)
				},
				disabled: disabled,
			},
			{
				label: "Eliminar",
				onClick: () => {
					setDisabled(true)
					fetch(datum.perfil_puesto, datum.id)
				},
				disabled: disabled,
			},
		],
		[disabled, fetch, datum.perfil_puesto, datum.id, setOpen]
	)

	return (
		<Fragment>
			<MasterDialog {...{ open, setOpen, title: "Eliminar " + name, buttons }}>
				<Typography color="text.primary">{messageDelete(datum)}</Typography>
			</MasterDialog>
		</Fragment>
	)
}
